<template>
	<div class="szpx_box">
		<div class="szpx_title">
			<div class="szpx_title1">{{title}}</div>
			<div>
			<!-- <el-button class="szpx_button" type="danger" size="small" @click="xj">一键删除</el-button> -->
			<el-button class="szpx_button" type="danger" size="small" @click="xj">新建比赛</el-button>
			</div>
		</div>
		<div class="szpx_content">
			<div class="szpx_contents">
				<el-table :data="tableData" border style="width: 100%">
					<el-table-column prop="title" label="标题">
					</el-table-column>
					<el-table-column prop="mid" label="比赛组别" width="120">
					</el-table-column>
					<el-table-column prop="province" label="比赛时间" width="240">
						<template slot-scope="scope">
							<span>{{scope.row.bs_start_time}}</span>
							<span>——</span>
							<span>{{scope.row.bs_end_time}}</span>
						</template>	
					</el-table-column>
					<el-table-column prop="name" label="状态" width="120">
					</el-table-column>
					<el-table-column label="操作" width="280">
						<template slot-scope="scope">
							<el-button  type="success" size="mini" @click="tzcy(scope.row.id)">成员</el-button>
							<el-button @click="handleClick(scope.row.id)" type="success" size="mini">查看</el-button>
							<el-button type="warning" size="mini" @click="bjclick(scope.row.id)">编辑</el-button>
							<el-button type="danger" size="mini" @click="remove(scope.row.id)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="studio_page" style="margin-bottom: 30px;padding-top: 15px;">
					<el-pagination
					   background
					  :page-size="10"
					  :pager-count="11"
					  @current-change="changs"
					  layout="prev, pager, next"
					  :total="count">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		game
	} from '@/axios'
	export default {
		data() {
			return {
				input: '',
				page:1,
				count:0,
				tableData: [],
				data: '',
				list: [],
				title: '新闻管理',
				show: false,
			}
		},
		created() {
			this.lists();
		},
		mounted() {

		},
		methods: {
			// 列表
			lists() {
				let that = this
				game.gamelist({
					uid:sessionStorage.getItem("id"),
					rid:sessionStorage.getItem("rid"),
					per_page:that.page,
					token: sessionStorage.getItem("token")
				}).then(res => {
					if (res.code == 200) {
						console.log(res)
						that.tableData=res.data.list;
						that.count=res.data.count;
					}
				})
			},
			changs(val){
				this.page=val;
				this.lists();
			},
			// 新建
			xj() {
				let that = this
				that.$router.push({
					path: '/gameadd',
					query: {
						id: '',
						// wid: that.id
					}
				})
			},
			// 编辑
			bjclick(id){
				let that = this
				that.$router.push({
					path: '/gameadd',
					query: {
						id: id,
						// wid: that.id
					}
				})
			},
			// 查看成员
			tzcy(id){
				let that = this;
				that.$router.push({
					path: '/cylist',
					query: {
						id: id,
						// wid: that.id
					}
				})
			},
			// 删除
			remove(id){
				let that = this;
				that.$confirm('确定删除当前比赛？', '删除比赛', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					game.removegame({
						uid:sessionStorage.getItem("id"),
						gid:id,
						token: sessionStorage.getItem("token")
					}).then(res => {
						if (res.code == 200) {
							this.$message({
								message: '比赛删除成功',
								type: 'success'
							});
						}
						that.lists();
					})
				}).catch(() => {
					
				});
				
			},
			// 查看
			handleClick(id){
				let that = this
				that.$router.push({
					path: '/gameadd',
					query: {
						id: id,
						type:true,
					}
				})
			}
		}
	}
</script>

<style>
</style>
